





























































import { Component, Vue, Prop } from 'vue-property-decorator';

type StreakCountSize = 'small' | 'medium' | 'big';

@Component({})
export default class StreakCount extends Vue {
  @Prop(Number) readonly currentStreak!: number;
  @Prop(Number) readonly progress!: number;
  @Prop(String) readonly size!: StreakCountSize;
  @Prop(Boolean) readonly mobile?: boolean;

  private readonly diameter: number;

  constructor() {
    super();
    const sizes = {
      small: 60,
      medium: 72,
      big: 90,
    };

    this.diameter = sizes[this.size];
  }

  private get center(): number {
    return this.diameter / 2;
  }

  private get stroke(): number {
    return this.diameter / 15;
  }

  private get normalizedRadius(): number {
    return this.diameter / 2 - this.stroke * 2;
  }

  private get circumference(): number {
    return 2 * Math.PI * this.normalizedRadius;
  }

  private get shouldShowLighting(): boolean {
    if (this.size === 'small') {
      return this.currentStreak === 0;
    }
    if (this.size === 'medium') {
      return this.currentStreak === 0 || this.progress === 1;
    }

    return true;
  }

  private get shouldShowCurrentStreak(): boolean {
    return this.size === 'big' || this.currentStreak > 0;
  }

  private get textXPosition(): any {
    if (this.size === 'big') {
      return '46%';
    }

    return this.currentStreak >= 10 ? '57%' : '52%';
  }

  private get strokeDashOffsetVal(): number {
    return this.circumference - this.progress * this.circumference;
  }

  private get streakTriumph(): { [key: string]: boolean } {
    return {
      zero: this.currentStreak === 0,
      nice: this.currentStreak > 0 && this.currentStreak < 10,
      impressive: this.currentStreak >= 10 && this.currentStreak < 100,
      unbelievable: this.currentStreak >= 100,
    };
  }
}
